<template>
    <transition name="fade">
        <div>
            <div class="row justify-content-center">
                <div class="col-lg-10 col-md-12 col-sm-12">
                    <div class="card">
                        <div class="card-header">
                            <h3 class="card-title bold">One-Time Pin Authentication</h3>
                        </div>
                        <div class="card-body text-justify">
                            <div class="alert alert-danger alert-dismissible mb-2" v-if="msg">
                                <button type="button" class="close mt-n1" data-dismiss="alert" aria-hidden="true" @click="msg=null">&times;</button>
                                <span>{{msg}}</span>
                            </div>
                            <p class="card-text">For better security, we sent an One-Time Pin(OTP) to your registered mobile number ending<b class="ml-2">{{formOTP.hash_num}}</b>.</p>
                            <p class="card-text">Kindly Input below the OTP. It will expire in the next <b>4 minutes </b>.</p>
                            <center>
                                <!-- <p><b>Enter the 6-digit you received</b></p> -->
                                <input inputmode="numeric" type="text" class="text-center form-control form-control-lg otp" maxlength="6" placeholder="Enter code" v-model="formOTP.code" :class="{ 'is-invalid': submitting && $v.formOTP.code.$error }" />
                                <p class="fs-13 danger m-0 p-0" v-if="submitting && $v.formOTP.code.$error">Verification code must have 6 digit</p>
                                <button type="button" class="btn btn-link mt-2" :disabled="formOTP.counting" @click="$emit('resend')">
                                    <countdown v-if="formOTP.counting" :time="formOTP.countdown" @end="handleCountdownEnd">
                                        <template slot-scope="props">Resend again {{ props.minutes }} minutes, {{ props.seconds }} seconds later</template>
                                    </countdown>
                                    <span v-else>Not received? Click here to resend code</span>
                                </button>
                                <br>
                                <!-- <button type="button" class="btn btn-link" data-toggle="modal" data-target="#updateMobileModal">Update your Mobile Number</button> -->
                            </center>
                        </div>
                        <div class="card-footer">
                            <!-- <button class="btn btn-primary" @click=""><i class="fas fa-arrow-left mr-1"></i>Back</button> -->
                            <button class="btn btn-primary float-right" @click="submitOTP">Next<i class="fas fa-arrow-right ml-1"></i></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import {
        required,
        minLength
    } from 'vuelidate/lib/validators';
    export default {

        props: ['formOTP'],

        data() {
            return {
                submitting: false,
                msg: null,
            }
        },
        validations: {
            formOTP: {
                code: {
                    required,
                    minLength: minLength(6)
                },
            },
        },
        created() {},
        methods: {
            handleCountdownEnd: function() {
                this.$parent.prop_otp.counting = false;
            },
            submitOTP: _.debounce(function() {
                this.submitting = true;
                this.$v.formOTP.$touch();
                if (this.$v.formOTP.$invalid) {


                } else {
                    this.$parent.payloading = true;
                    axios.post('/api/v2-verify-otp', {
                            // mobile_number: this.formOTP.number,
                            // code: this.formOTP.code,
                            // borrower_id: this.formOTP.borrower_id,

                            mobile_number: this.formOTP.number,
                            borrower_id: this.formOTP.borrower_id,
                            session_id: this.formOTP.otp_id,
                            token: this.formOTP.code
                        })
                        .then(res => {
                            this.$parent.payloading = false;

                            let data = res.data;
                            let stat = data.otp_stat;

                            if (stat == 1) {
                                this.$parent.getIndex();
                            } else {
                                this.msg = data.msg;

                                setTimeout(() => {
                                    this.msg = null;
                                }, 10000);
                            }
                        }).catch(error => {
                            this.$parent.payloading = false;
                            Swal.fire({
                                title: 'Transaction Failed',
                                text: "Invalid or expired verification code",
                                icon: 'warning',
                                showCancelButton: false,
                            }).then((result) => {
                                if (result.value) {
                                    window.location.reload();
                                }
                            })
                        })
                }
            }, 500),
        },
        computed: {},

        mounted() {}
    }
</script>
<style scoped>
    .otp {
        -webkit-transition: none;
        transition: none;
        max-width: 300px;
        font-size: 24px;
        /* font-weight: 700; */
    }

    ::-webkit-input-placeholder {
        /* Chrome/Opera/Safari */
        font-size: 18px !important;
    }

    ::-moz-placeholder {
        /* Firefox 19+ */
        font-size: 18px !important;
    }

    :-ms-input-placeholder {
        /* IE 10+ */
        font-size: 18px !important;
    }

    :-moz-placeholder {
        /* Firefox 18- */
        font-size: 18px !important;
    }
</style>